export default __webpack_public_path__ + "static/media/trafic-small.a0812870.jpg";